export const FirstPromoter = {
  /**
   * NOTA:
   * El script principal (init + click + carga de fpr.js) está en `index.html`.
   * Aquí solo dejamos helpers para disparar eventos (p.ej. referral).
   */
  _ensureQueue() {
    if (typeof window === "undefined") return
    const w = window as any
    if (w.fpr) return
    w.fpr = function () {
      w.fpr.q = w.fpr.q || []
      w.fpr.q[arguments[0] === "set" ? "unshift" : "push"](arguments)
    }
  },

  referral(email: string) {
    if (typeof window === "undefined") return
    if ((window as any).Cypress) return

    const hasFpr = localStorage.getItem("client_reference_id")
    if (!hasFpr) return

    FirstPromoter._ensureQueue()
    ;(window as any).fpr?.("referral", { email })
  },
};
